import React from 'react';
import PropTypes from 'prop-types';

import './inputComponent.css';

const InputComponent = ({
  disabled,
  error,
  id,
  name,
  onChange,
  onKeyDown,
  placeholder,
  spellCheck = true,
  type,
  value,
}) => {
  return (
    <React.Fragment>
      <input
        className={`et-input-component ${error ? 'et-input-error' : ''}`}
        onChange={onChange}
        value={value}
        id={id}
        name={name}
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        onKeyDown={onKeyDown}
        spellCheck={spellCheck}
      />
      {error && <p className="et-input-alert">{error}</p>}
    </React.Fragment>
  );
};

export default InputComponent;

InputComponent.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  text: PropTypes.string,
  image: PropTypes.node,
  onChange: PropTypes.func,
  isDisabled: PropTypes.bool,
  error: PropTypes.string,
};
